module.exports = __webpack_public_path__ + "static/media/employees.5952f7cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/employees.svg
// module id = 864
// module chunks = 0